__turbopack_context__.v({
  "disabled": "linkButton-module-scss-module__0xxGgW__disabled",
  "inverted": "linkButton-module-scss-module__0xxGgW__inverted",
  "linkButton": "linkButton-module-scss-module__0xxGgW__linkButton",
});
